module.exports = __webpack_public_path__ + "static/img/suoyouquan.58225b03.png";